"use client"; 
import { useState } from "react";
import Link from "next/link";
import CustomButton from "../Buttons/CustomButton";
import cl1Tab from "@/Helper/images/client_centric_approach.png";
import cl2Tab from "@/Helper/images/commitment_to_innovation.png";
import cl3Tab from "@/Helper/images/ethical_data_practices.png";
import cl4Tab from "@/Helper/images/end_to_end_expertise.png";

import Image from "next/image";

export default function IndustryComponent() {
  const [activeTab, setActiveTab] = useState(0); // State for active tab

  const handleTabClick = (index) => {
    setActiveTab(index); // Update the active tab state
  };

  const tabTitles = [
    "Data-Driven Sustainability",
    "Track, Measure, Improve",
    "Predictive Environmental Insights",
    "Compliance and Reporting Made Easy",
    "Driving Green Innovation",
    
   
  ];

  const tabContent = [
    {
      heading: "Data-Driven Sustainability",
      subheading: " We empower your sustainability initiatives with advanced analytics, turning environmental and social data into actionable insights for lasting impact.",
      image: cl1Tab, 
    },
    {
      heading: "Track, Measure, Improve",
      subheading: " Our solutions help you track key sustainability metrics, measure progress, and identify opportunities to reduce your environmental footprint. ",
      image: cl2Tab,
    },
    {
      heading: "Predictive Environmental Insights",
      subheading: " Using AI and machine learning, we forecast trends and identify risks, enabling proactive strategies to meet sustainability goals. ",
      image: cl3Tab,
    },
    {
      heading: "Compliance and Reporting Made Easy",
      subheading: " We streamline sustainability reporting and ensure compliance with global regulations, providing transparent, accurate, and real-time data.",
      image: cl4Tab,
    },
    {
      heading: "Driving Green Innovation",
      subheading: " By leveraging data analytics, we help you uncover new opportunities for green innovation, making sustainability a competitive advantage while reducing costs.",
      image: cl4Tab,
    },
   
  ];

  return (
    <div className="industry_cat_section1">
      {/* Navigation Tabs */}
      <div className="industry_cat_nav1">
        {tabTitles.map((tab, index) => (
          <p
            key={index}
            className={index === activeTab ? "active" : ""}
            onClick={() => handleTabClick(index)}
            
          >
            {tab}
          </p>
        ))}
      </div>

      {/* Tab Content */}
      {tabContent.map((content, index) => (
        <div
          key={index}
          className={`industry_container1 ${
            index === activeTab ? "active" : ""
          }`}
        >
          <div className="industry_left_content1">
            <p className="heading1">{content.heading}</p>
            <p className="subheading1">{content.subheading}</p>
            
          </div>
          <div className="industry_right_content1">
            <div className="slider_bg1 normal_bg1">
            <Image
              src={tabContent[activeTab].image}
              alt={tabContent[activeTab].heading}
              width={457}
              height={257}
              className="productbanner_imageslider"
              loading="eager"
            />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
